"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SchemaField = void 0;
const react_1 = __importStar(require("react"));
const core_1 = require("@rjsf/core");
const utils_1 = require("@rjsf/utils");
const FormattedTextEditorWidget_1 = require("../FormattedTextEditor/FormattedTextEditorWidget");
const SquizImageWidget_1 = require("../SquizImage/SquizImageWidget");
const SquizLinkWidget_1 = require("../SquizLink/SquizLinkWidget");
const MatrixAssetWidget_1 = require("../MatrixAsset/MatrixAssetWidget");
const react_json_schema_utils_1 = require("@squiz/react-json-schema-utils");
const FeatureFlags_1 = require("../../../../context/FeatureFlags/FeatureFlags");
const ViperFormattedTextEditorWidget_1 = require("../ViperFormattedTextEditor/ViperFormattedTextEditorWidget");
const DisabledFormattedTextWidget_1 = require("../DisabledFormattedTextWidget/DisabledFormattedTextWidget");
const { fields: { SchemaField: SchemaFieldBase }, } = (0, core_1.getDefaultRegistry)();
const SchemaField = (props) => {
    const { index, schema, uiSchema, ...rest } = props;
    const { disableFTEInputs, useViperForFTEInputs } = (0, react_1.useContext)(FeatureFlags_1.FeatureFlags);
    const formattedTextField = useViperForFTEInputs ? ViperFormattedTextEditorWidget_1.ViperFormattedTextEditorWidget : FormattedTextEditorWidget_1.FormattedTextEditorWidget;
    const enumRadioLimit = 4;
    let renderEnumAsRadio = false;
    if (schema.enum && schema.format !== 'matrix-asset-uri') {
        if (schema.enum.length <= enumRadioLimit && index === undefined) {
            renderEnumAsRadio = true;
        }
    }
    // UI schema is dynamically rewritten rather than passed into the RJSF form so that
    // it can take into consideration conditions inside of the schema.
    const rewrittenUiSchema = (0, react_1.useMemo)(() => {
        switch (schema.customType?.customType || (0, utils_1.getSchemaType)(schema)) {
            case react_json_schema_utils_1.CustomJsonSchemaType.FormattedText:
                return {
                    'ui:label': true,
                    'ui:field': disableFTEInputs ? DisabledFormattedTextWidget_1.DisabledFormattedTextWidget : formattedTextField,
                };
            case react_json_schema_utils_1.CustomJsonSchemaType.SquizImage:
                return {
                    'ui:label': true,
                    'ui:field': SquizImageWidget_1.SquizImageWidget,
                };
            case react_json_schema_utils_1.CustomJsonSchemaType.SquizLink:
                return {
                    'ui:label': true,
                    'ui:field': SquizLinkWidget_1.SquizLinkWidget,
                };
            case react_json_schema_utils_1.StandardJsonSchemaType.Integer:
                if (renderEnumAsRadio) {
                    return { 'ui:widget': 'radio' };
                }
                break;
            case react_json_schema_utils_1.StandardJsonSchemaType.String:
                if (!schema.enum && schema.format === 'multi-line') {
                    return { 'ui:widget': 'textarea' };
                }
                else if (!schema.enum && schema.format === 'matrix-asset-uri') {
                    return {
                        'ui:label': true,
                        'ui:field': MatrixAssetWidget_1.MatrixAssetWidget,
                    };
                }
                else if (renderEnumAsRadio) {
                    return { 'ui:widget': 'radio' };
                }
        }
        return uiSchema;
    }, [schema, uiSchema]);
    return react_1.default.createElement(SchemaFieldBase, { schema: schema, uiSchema: rewrittenUiSchema, ...rest });
};
exports.SchemaField = SchemaField;
